import { SettingsGroup } from "./types";

/** Retail (productId = 3) — add group definitions here. */
export const retailSettingsGroups: SettingsGroup[] = [];
